import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./Question11.css";
import Clock from "./images/clock11.gif";
import Expert from "./images/expert.png";

const Question11 = ({ onAnswer, userResponse }) => {
  const question = {
    title:
      "Have you ever wished there was a way to get access to experts who can make sure your research work is high-quality, with zero waste of time?",
    questionImage: Clock,
    questionImage2: Expert,
    options: [
      { label: "Yes, definitely", image: "/path-to-option1-image.jpg" },
      { label: "I’ve thought about it", image: "/path-to-option2-image.jpg" },
      { label: "Maybe", image: "/path-to-option3-image.jpg" },
      { label: "Not at all", image: "/path-to-option4-image.jpg" },
    ],
  };

  const handleNext = () => {
    if (!userResponse[question.title]) {
      return;
    }
    setTimeout(() => {
      onAnswer(question.title, null);
    }, 1000);
  };

  return (
    <AnimatePresence>
      <motion.div
        className="question11-container"
        initial={{ opacity: 0, x: "20%" }}
        animate={{ opacity: 1, x: 0 }}
        exit={{ opacity: 0, x: "-100vw" }}
        transition={{ duration: 1 }}
      >
        {question.questionImage && (
          <img
            className="question11-img"
            src={question.questionImage}
            alt="Clock"
          />
        )}

        {question.questionImage2 && (
          <img
            className="question11-img2"
            src={question.questionImage2}
            alt="Expert"
          />
        )}

        <motion.h2
          className="question11-head"
          initial={{ opacity: 0, x: "-50%" }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, y: "-50%" }}
          transition={{ duration: 0.8 }}
        >
          {question.title}
        </motion.h2>

        <motion.div
          className="option11-container"
          initial={{ opacity: 0, x: "20%" }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: "10%" }}
          transition={{ duration: 1, delay: 0.3 }}
        >
          {question.options.map((option, index) => {
            const isChecked = userResponse[question.title] === option.label;
            return (
              <motion.label
                key={index}
                className={`radio11-option ${isChecked ? "checked" : ""}`}
                htmlFor={`option-${index}`}
                initial={{ opacity: 0, x: "20%" }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: "10%" }}
                transition={{
                  duration: 0.5,
                  delay: 0.2 + index * 0.2,
                }}
              >
                <input
                  type="radio"
                  id={`option-${index}`}
                  name={`question-${question.title}`}
                  value={option.label}
                  checked={isChecked}
                  onChange={() => onAnswer(question.title, option.label)}
                />
                <span className="radio11-label">{option.label}</span>
              </motion.label>
            );
          })}
        </motion.div>

        <motion.button
          type="submit"
          initial={{ opacity: 0, x: "20%" }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, y: "10%" }}
          transition={{ duration: 0.8, delay: 1 }}
          onClick={handleNext}
          disabled={!userResponse[question.title]}
        >
          Next Question
        </motion.button>
      </motion.div>
    </AnimatePresence>
  );
};

export default Question11;
